module.exports = __webpack_public_path__ + "static/img/ts_safe.580c0e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/ts_safe.jpg
// module id = HjBp
// module chunks = 0